(function () {
  if (window.FocusCardsCarouselScriptLoaded) return;
  window.FocusCardsCarouselScriptLoaded = true;

  class FocusCardsCarousel {
    constructor(sectionRoot) {
      this.section = sectionRoot;
      this.root = sectionRoot.querySelector('[data-focus-cards]');
      if (!this.root) return;

      this.viewport = this.root.querySelector('[data-focus-cards-viewport]');
      this.stage = this.root.querySelector('[data-focus-cards-stage]');
      this.cards = Array.from(this.root.querySelectorAll('[data-focus-card]'));
      this.prevButton = this.root.querySelector('[data-focus-prev]');
      this.nextButton = this.root.querySelector('[data-focus-next]');
      this.indicatorPrevButton = this.root.querySelector('[data-focus-indicator-prev]');
      this.indicatorNextButton = this.root.querySelector('[data-focus-indicator-next]');
      this.dots = Array.from(this.root.querySelectorAll('[data-focus-dot]'));

      if (!this.cards.length) return;

      this.current = Number(this.root.dataset.initialIndex || 0);
      if (Number.isNaN(this.current) || this.current < 0 || this.current >= this.cards.length) {
        this.current = 0;
      }

      this.pointerStartX = 0;
      this.pointerEndX = 0;
      this.pointerActiveId = null;
      this.pointerStartCard = null;
      this.isPointerActive = false;
      this.hasDragged = false;
      this.suppressClickUntil = 0;
      this.isTransitioning = false;
      this.transitionTimer = null;
      this.wheelLock = false;
      this.wheelLockTimer = null;
      this.wheelGestureActive = false;
      this.wheelGestureConsumed = false;
      this.wheelGestureTimer = null;
      this.wheelAccumulatedX = 0;
      this.resizeRaf = null;
      this.scrollRaf = null;
      this.scrollEndTimer = null;
      this.mode = null;
      this.dotHandlers = [];
      this.isPointerOver = false;
      this.mobileScrollTargetIndex = null;

      this.mobileQuery = window.matchMedia('(max-width: 749.999px)');
      this.tabletQuery = window.matchMedia('(min-width: 481px) and (max-width: 989px)');

      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onIndicatorPrevClick = this.onIndicatorPrevClick.bind(this);
      this.onIndicatorNextClick = this.onIndicatorNextClick.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onPointerCancel = this.onPointerCancel.bind(this);
      this.onPointerEnter = this.onPointerEnter.bind(this);
      this.onPointerLeave = this.onPointerLeave.bind(this);
      this.onWheel = this.onWheel.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onContextMenu = this.onContextMenu.bind(this);
      this.onDragStart = this.onDragStart.bind(this);

      this.bindEvents();
      this.refresh();
    }

    bindEvents() {
      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      if (this.indicatorPrevButton) this.indicatorPrevButton.addEventListener('click', this.onIndicatorPrevClick);
      if (this.indicatorNextButton) this.indicatorNextButton.addEventListener('click', this.onIndicatorNextClick);

      this.dots.forEach((dot, index) => {
        const handler = () => this.goTo(index);
        dot.addEventListener('click', handler);
        this.dotHandlers.push({ dot, handler });
      });

      window.addEventListener('resize', this.onResize, { passive: true });

      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener('change', this.onResize);
      } else if (this.mobileQuery.addListener) {
        this.mobileQuery.addListener(this.onResize);
      }

      if (this.viewport) {
        this.viewport.addEventListener('pointerdown', this.onPointerDown, { passive: false });
        this.viewport.addEventListener('pointermove', this.onPointerMove, { passive: false });
        this.viewport.addEventListener('pointerup', this.onPointerUp, { passive: true });
        this.viewport.addEventListener('pointercancel', this.onPointerCancel, { passive: true });
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('wheel', this.onWheel, { passive: false });
      }

      this.section.addEventListener('pointerenter', this.onPointerEnter);
      this.section.addEventListener('pointerleave', this.onPointerLeave);
      this.section.addEventListener('contextmenu', this.onContextMenu);
      this.section.addEventListener('dragstart', this.onDragStart);
      document.addEventListener('keydown', this.onKeyDown);

      this.cards.forEach((card, index) => {
        card.addEventListener('click', (event) => {
          if (Date.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }

          if (index !== this.current) {
            this.goTo(index);
          }
        });
      });
    }

    destroy() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.indicatorPrevButton) this.indicatorPrevButton.removeEventListener('click', this.onIndicatorPrevClick);
      if (this.indicatorNextButton) this.indicatorNextButton.removeEventListener('click', this.onIndicatorNextClick);

      this.dotHandlers.forEach(({ dot, handler }) => {
        dot.removeEventListener('click', handler);
      });
      this.dotHandlers = [];

      window.removeEventListener('resize', this.onResize);

      if (this.mobileQuery.removeEventListener) {
        this.mobileQuery.removeEventListener('change', this.onResize);
      } else if (this.mobileQuery.removeListener) {
        this.mobileQuery.removeListener(this.onResize);
      }

      if (this.viewport) {
        this.viewport.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport.removeEventListener('pointermove', this.onPointerMove);
        this.viewport.removeEventListener('pointerup', this.onPointerUp);
        this.viewport.removeEventListener('pointercancel', this.onPointerCancel);
        this.viewport.removeEventListener('scroll', this.onScroll);
        this.viewport.removeEventListener('wheel', this.onWheel);
      }

      this.section.removeEventListener('pointerenter', this.onPointerEnter);
      this.section.removeEventListener('pointerleave', this.onPointerLeave);
      this.section.removeEventListener('contextmenu', this.onContextMenu);
      this.section.removeEventListener('dragstart', this.onDragStart);
      document.removeEventListener('keydown', this.onKeyDown);

      if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
      if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
      if (this.scrollEndTimer) window.clearTimeout(this.scrollEndTimer);
      if (this.wheelLockTimer) window.clearTimeout(this.wheelLockTimer);
      if (this.wheelGestureTimer) window.clearTimeout(this.wheelGestureTimer);
      if (this.transitionTimer) window.clearTimeout(this.transitionTimer);
    }

    isMobileNativeScroll() {
      return this.mobileQuery.matches && this.root.dataset.mobileNativeScroll === 'true';
    }

    isTabletCarousel() {
      return this.tabletQuery.matches && !this.isMobileNativeScroll();
    }

    updateTabletCarouselMetrics() {
      if (!this.root) return;

      if (!this.isTabletCarousel()) {
        delete this.root.dataset.tabletCarousel;
        this.root.style.removeProperty('--tablet-side-offset');
        return;
      }

      this.root.dataset.tabletCarousel = 'true';

      const referenceCard = this.cards[this.current] || this.cards[0];
      if (!referenceCard) return;

      // offsetWidth is deliberately used rather than getBoundingClientRect().width:
      // it gives the unscaled rendered card width even when the card is currently
      // a side preview or is in the middle of a transform transition.
      const cardWidth = referenceCard.offsetWidth;
      if (!cardWidth) return;

      const rootStyles = window.getComputedStyle(this.root);
      const configuredGap = parseFloat(rootStyles.getPropertyValue('--tablet-card-gap'));
      const configuredScale = parseFloat(rootStyles.getPropertyValue('--tablet-side-scale'));

      const gap = Number.isFinite(configuredGap) ? configuredGap : 14;
      const sideScale = Number.isFinite(configuredScale) ? configuredScale : 0.92;

      // Centre-to-centre distance required for:
      // active half-width + scaled preview half-width + a real visible gap.
      const offset = (cardWidth * (1 + sideScale)) / 2 + gap;

      this.root.style.setProperty('--tablet-side-offset', `${Math.ceil(offset)}px`);
    }

    isDesktopCarousel() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    refresh() {
      const nextMode = this.isMobileNativeScroll() ? 'mobile-native' : 'carousel';
      const modeChanged = this.mode !== nextMode;
      this.mode = nextMode;
      this.updateTabletCarouselMetrics();

      if (this.mode === 'mobile-native') {
        this.clearMeasuredHeights();
        this.renderMobileNative();

        if (modeChanged) {
          requestAnimationFrame(() => {
            this.scrollToCurrent(false);
          });
        }

        return;
      }

      this.mobileScrollTargetIndex = null;
      this.measure();
      this.renderCarousel();
    }

    onPrevClick() {
      this.prev();
    }

    onNextClick() {
      this.next();
    }

    onIndicatorPrevClick() {
      const baseIndex = this.getNavigationIndex();

      if (this.isDesktopCarousel()) {
        if (this.cards.length <= 1) return;
        const nextIndex = (baseIndex - 1 + this.cards.length) % this.cards.length;
        this.goTo(nextIndex);
        return;
      }

      if (baseIndex <= 0) return;
      this.goTo(baseIndex - 1);
    }

    onIndicatorNextClick() {
      const baseIndex = this.getNavigationIndex();

      if (this.isDesktopCarousel()) {
        if (this.cards.length <= 1) return;
        const nextIndex = (baseIndex + 1) % this.cards.length;
        this.goTo(nextIndex);
        return;
      }

      if (baseIndex >= this.cards.length - 1) return;
      this.goTo(baseIndex + 1);
    }

    onResize() {
      if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);

      this.resizeRaf = requestAnimationFrame(() => {
        this.refresh();
      });
    }

    onPointerDown(event) {
      if (this.isMobileNativeScroll()) return;
      if (!event.isPrimary && event.pointerType !== 'mouse') return;

      event.preventDefault();

      if (this.viewport && typeof this.viewport.focus === 'function') {
        try {
          this.viewport.focus({ preventScroll: true });
        } catch (error) {
          this.viewport.focus();
        }
      }

      this.isPointerActive = true;
      this.hasDragged = false;
      this.pointerStartX = event.clientX;
      this.pointerEndX = event.clientX;
      this.pointerActiveId = event.pointerId;
      this.pointerStartCard = this.getCardFromTarget(event.target);

      if (this.viewport && this.viewport.setPointerCapture && event.pointerId !== undefined) {
        try {
          this.viewport.setPointerCapture(event.pointerId);
        } catch (error) {
          // Some browsers can throw if pointer capture is unavailable for this event.
        }
      }

      if (this.viewport) this.viewport.classList.add('is-dragging');
    }

    onPointerMove(event) {
      if (this.isMobileNativeScroll()) return;
      if (!this.isPointerActive) return;
      if (this.pointerActiveId !== null && event.pointerId !== this.pointerActiveId) return;

      this.pointerEndX = event.clientX;

      if (Math.abs(this.pointerEndX - this.pointerStartX) > 8) {
        this.hasDragged = true;
        event.preventDefault();
      }
    }

    onPointerUp(event) {
      if (this.isMobileNativeScroll()) return;
      if (!this.isPointerActive) return;
      if (this.pointerActiveId !== null && event.pointerId !== this.pointerActiveId) return;

      this.finishPointerInteraction(event.clientX, event.target);
    }

    onPointerCancel() {
      this.resetPointerInteraction();
    }

    onPointerEnter() {
      this.isPointerOver = true;
    }

    onPointerLeave() {
      this.isPointerOver = false;
      this.mobileScrollTargetIndex = null;
    }

    finishPointerInteraction(clientX, target) {
      this.pointerEndX = clientX;
      const delta = this.pointerEndX - this.pointerStartX;
      const didDrag = Math.abs(delta) >= 35;
      const clickedCard = this.getCardFromTarget(target) || this.pointerStartCard;
      const clickedIndex = clickedCard ? this.cards.indexOf(clickedCard) : -1;

      this.resetPointerInteraction();

      if (!didDrag) {
        if (this.isDesktopCarousel() && clickedIndex >= 0 && clickedIndex !== this.current) {
          this.suppressClickUntil = Date.now() + 250;
          this.goTo(clickedIndex);
        }

        return;
      }

      this.suppressClickUntil = Date.now() + 450;

      if (delta > 0) {
        this.prev();
      } else {
        this.next();
      }
    }

    resetPointerInteraction() {
      this.isPointerActive = false;
      this.pointerActiveId = null;
      this.pointerStartCard = null;

      if (this.viewport) this.viewport.classList.remove('is-dragging');
    }

    onWheel(event) {
      if (this.isMobileNativeScroll()) return;

      const horizontalDelta = Number(event.deltaX || 0);
      const verticalDelta = Number(event.deltaY || 0);

      if (Math.abs(horizontalDelta) < 6 || Math.abs(horizontalDelta) <= Math.abs(verticalDelta)) return;

      event.preventDefault();

      /*
        Trackpads can emit a stream of momentum wheel events from one flick.
        Treat that stream as one gesture: once the accumulated horizontal movement
        passes the threshold, move one card only, then ignore the remaining
        momentum. As soon as the wheel stream is quiet, the next user flick can
        move one more card. This avoids both extremes: no 4-5 card skips, and no
        long lockout that blocks intentional repeated flicks.
      */
      if (!this.wheelGestureActive) {
        this.wheelGestureActive = true;
        this.wheelGestureConsumed = false;
        this.wheelAccumulatedX = 0;
      }

      if (this.wheelGestureTimer) window.clearTimeout(this.wheelGestureTimer);
      this.wheelGestureTimer = window.setTimeout(() => {
        this.wheelGestureActive = false;
        this.wheelGestureConsumed = false;
        this.wheelAccumulatedX = 0;
      }, 220);

      if (this.wheelGestureConsumed) return;

      this.wheelAccumulatedX += horizontalDelta;

      if (Math.abs(this.wheelAccumulatedX) < 36) return;

      this.wheelGestureConsumed = true;
      this.suppressClickUntil = Date.now() + 450;

      if (this.wheelAccumulatedX > 0) {
        this.next();
      } else {
        this.prev();
      }
    }

    shouldHandleKeyboardEvent(event) {
      if (!this.section) return false;

      const target = event.target;
      if (
        target &&
        target.closest &&
        target.closest('input, textarea, select, [contenteditable="true"], [contenteditable=""]')
      ) {
        return false;
      }

      const activeElement = document.activeElement;

      return (
        this.isPointerOver ||
        (target && this.section.contains(target)) ||
        (activeElement && this.section.contains(activeElement))
      );
    }

    onKeyDown(event) {
      if (event.defaultPrevented) return;
      if (!this.shouldHandleKeyboardEvent(event)) return;
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.prev();
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.next();
      }
    }

    onScroll() {
      if (!this.isMobileNativeScroll()) return;
      if (!this.viewport || !this.cards.length) return;

      if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
      if (this.scrollEndTimer) window.clearTimeout(this.scrollEndTimer);

      this.scrollRaf = requestAnimationFrame(() => {
        const viewportLeft = this.viewport.getBoundingClientRect().left;
        let closestIndex = this.current;
        let closestDistance = Infinity;

        this.cards.forEach((card, index) => {
          const cardLeft = card.getBoundingClientRect().left;
          const distance = Math.abs(cardLeft - viewportLeft);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex !== this.current) {
          this.current = closestIndex;

          if (this.mobileScrollTargetIndex === closestIndex) {
            this.mobileScrollTargetIndex = null;
          }

          this.renderMobileNative(false);
        } else {
          this.updateProgress();
        }

        this.scrollEndTimer = window.setTimeout(() => {
          this.snapCurrentCardFlush();
        }, 140);
      });
    }

    snapCurrentCardFlush() {
      if (!this.isMobileNativeScroll()) return;

      const targetIndex = this.mobileScrollTargetIndex !== null ? this.mobileScrollTargetIndex : this.current;
      this.scrollToIndex(targetIndex, true);
    }

    onContextMenu(event) {
      if (event.target && event.target.closest('.focus-card__icon-wrap')) {
        event.preventDefault();
      }
    }

    onDragStart(event) {
      if (event.target && event.target.closest('.focus-card__icon-wrap')) {
        event.preventDefault();
      }
    }

    getCardFromTarget(target) {
      if (!target || !target.closest) return null;

      const card = target.closest('[data-focus-card]');
      return card && this.cards.includes(card) ? card : null;
    }

    clearMeasuredHeights() {
      if (this.viewport) this.viewport.style.minHeight = '';
      if (this.stage) this.stage.style.minHeight = '';
    }

    measure() {
      let tallest = 0;

      this.cards.forEach((card) => {
        const prevVisibility = card.style.visibility;
        const prevPointerEvents = card.style.pointerEvents;
        const prevOpacity = card.style.opacity;

        card.style.visibility = 'hidden';
        card.style.pointerEvents = 'none';
        card.style.opacity = '1';

        const height = card.offsetHeight;
        if (height > tallest) tallest = height;

        card.style.visibility = prevVisibility;
        card.style.pointerEvents = prevPointerEvents;
        card.style.opacity = prevOpacity;
      });

      if (tallest > 0 && this.viewport) {
        this.viewport.style.minHeight = `${tallest}px`;
        if (this.stage) this.stage.style.minHeight = `${tallest}px`;
      }
    }

    getNavigationIndex() {
      if (this.isMobileNativeScroll() && this.mobileScrollTargetIndex !== null) {
        return this.mobileScrollTargetIndex;
      }

      return this.current;
    }

    prev() {
      const baseIndex = this.getNavigationIndex();
      const nextIndex = (baseIndex - 1 + this.cards.length) % this.cards.length;
      this.goTo(nextIndex);
    }

    next() {
      const baseIndex = this.getNavigationIndex();
      const nextIndex = (baseIndex + 1) % this.cards.length;
      this.goTo(nextIndex);
    }

    goTo(index, options = {}) {
      if (Number.isNaN(index) || index < 0 || index >= this.cards.length) return;

      if (this.isMobileNativeScroll()) {
        if (index === this.current && this.mobileScrollTargetIndex === null) return;

        this.mobileScrollTargetIndex = index;
        this.updateIndicatorButtons();
        this.scrollToIndex(index, options.smooth !== false);
        return;
      }

      if (index === this.current) return;
      if (!options.force && this.isTransitioning) return;

      this.current = index;
      this.lockTransition();
      this.renderCarousel();
    }

    lockTransition() {
      this.isTransitioning = true;

      if (this.transitionTimer) window.clearTimeout(this.transitionTimer);

      this.transitionTimer = window.setTimeout(() => {
        this.isTransitioning = false;
      }, 420);
    }

    scrollToCurrent(smooth) {
      this.scrollToIndex(this.current, smooth);
    }

    scrollToIndex(index, smooth) {
      if (!this.viewport || !this.cards[index]) return;

      const card = this.cards[index];
      const viewportLeft = this.viewport.getBoundingClientRect().left;
      const cardLeft = card.getBoundingClientRect().left;
      const delta = cardLeft - viewportLeft;

      if (Math.abs(delta) <= 1) return;

      this.viewport.scrollTo({
        left: this.viewport.scrollLeft + delta,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }

    distanceFromCurrent(index) {
      const total = this.cards.length;
      let distance = index - this.current;

      if (distance > total / 2) distance -= total;
      if (distance < -total / 2) distance += total;

      return distance;
    }

    renderMobileNative(updateRootIndex = true) {
      this.cards.forEach((card, index) => {
        card.classList.remove(
          'is-active',
          'is-prev',
          'is-next',
          'is-hidden-left',
          'is-hidden-right'
        );

        if (index === this.current) {
          card.classList.add('is-active');
          card.setAttribute('aria-hidden', 'false');
          card.tabIndex = 0;
        } else {
          card.setAttribute('aria-hidden', 'false');
          card.tabIndex = -1;
        }
      });

      this.updateArrows();
      this.updateProgress();

      if (updateRootIndex && this.root) {
        this.root.dataset.currentIndex = String(this.current);
      }
    }

    renderCarousel() {
      this.cards.forEach((card, index) => {
        card.classList.remove(
          'is-active',
          'is-prev',
          'is-next',
          'is-hidden-left',
          'is-hidden-right'
        );

        const distance = this.distanceFromCurrent(index);

        if (distance === 0) {
          card.classList.add('is-active');
          card.setAttribute('aria-hidden', 'false');
          card.tabIndex = 0;
        } else if (distance === -1) {
          card.classList.add('is-prev');
          card.setAttribute('aria-hidden', 'false');
          card.tabIndex = -1;
        } else if (distance === 1) {
          card.classList.add('is-next');
          card.setAttribute('aria-hidden', 'false');
          card.tabIndex = -1;
        } else if (distance < 0) {
          card.classList.add('is-hidden-left');
          card.setAttribute('aria-hidden', 'true');
          card.tabIndex = -1;
        } else {
          card.classList.add('is-hidden-right');
          card.setAttribute('aria-hidden', 'true');
          card.tabIndex = -1;
        }
      });

      this.updateArrows();
      this.updateProgress();

      if (this.root) {
        this.root.dataset.currentIndex = String(this.current);
      }
    }

    updateArrows() {
      if (!this.cards.length) return;

      const isSingle = this.cards.length <= 1;

      if (this.prevButton) this.prevButton.disabled = isSingle;
      if (this.nextButton) this.nextButton.disabled = isSingle;
    }

    updateProgress() {
      const total = this.cards.length;
      if (!total) return;


      this.dots.forEach((dot, index) => {
        const isActive = index === this.current;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        dot.setAttribute(
          'aria-label',
          `Show card ${index + 1} of ${total}${isActive ? ', current card' : ''}`
        );
      });

      this.updateIndicatorButtons();
    }

    updateIndicatorButtons() {
      if (!this.indicatorPrevButton || !this.indicatorNextButton) return;

      if (this.isDesktopCarousel()) {
        const isSingle = this.cards.length <= 1;

        this.indicatorPrevButton.disabled = isSingle;
        this.indicatorNextButton.disabled = isSingle;
        this.indicatorPrevButton.classList.toggle('is-hidden', isSingle);
        this.indicatorNextButton.classList.toggle('is-hidden', isSingle);
        this.indicatorPrevButton.setAttribute('aria-hidden', isSingle ? 'true' : 'false');
        this.indicatorNextButton.setAttribute('aria-hidden', isSingle ? 'true' : 'false');
        return;
      }

      const baseIndex = this.getNavigationIndex();
      const canGoPrev = baseIndex > 0;
      const canGoNext = baseIndex < this.cards.length - 1;

      this.indicatorPrevButton.disabled = !canGoPrev;
      this.indicatorNextButton.disabled = !canGoNext;
      this.indicatorPrevButton.classList.toggle('is-hidden', !canGoPrev);
      this.indicatorNextButton.classList.toggle('is-hidden', !canGoNext);
      this.indicatorPrevButton.setAttribute('aria-hidden', canGoPrev ? 'false' : 'true');
      this.indicatorNextButton.setAttribute('aria-hidden', canGoNext ? 'false' : 'true');
    }
  }

  window.FocusCardsCarouselInstances = window.FocusCardsCarouselInstances || new Map();

  function resolveSectionRoot(target) {
    if (!target) return null;
    if (target.classList && target.classList.contains('focus-cards-section')) return target;
    return target.querySelector ? target.querySelector('.focus-cards-section') : null;
  }

  function getSectionKey(sectionRoot) {
    if (!sectionRoot) return null;
    return sectionRoot.dataset.sectionId || sectionRoot.id || null;
  }

  function initFocusCardsSection(target) {
    const sectionRoot = resolveSectionRoot(target);
    if (!sectionRoot) return;

    const key = getSectionKey(sectionRoot);
    if (!key) return;

    const existing = window.FocusCardsCarouselInstances.get(key);
    if (existing) {
      existing.destroy();
      window.FocusCardsCarouselInstances.delete(key);
    }

    const instance = new FocusCardsCarousel(sectionRoot);
    window.FocusCardsCarouselInstances.set(key, instance);
  }

  function initAllFocusCardsSections(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll('.focus-cards-section');
    sections.forEach((section) => initFocusCardsSection(section));
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllFocusCardsSections(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initFocusCardsSection(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const sectionRoot = resolveSectionRoot(event.target);
    if (!sectionRoot) return;

    const key = getSectionKey(sectionRoot);
    if (!key) return;

    const existing = window.FocusCardsCarouselInstances.get(key);
    if (existing) {
      existing.destroy();
      window.FocusCardsCarouselInstances.delete(key);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    const blockEl = event.target;
    if (!blockEl) return;

    const sectionRoot = blockEl.closest('.focus-cards-section');
    if (!sectionRoot) return;

    const key = getSectionKey(sectionRoot);
    const instance = window.FocusCardsCarouselInstances.get(key);
    if (!instance || !instance.cards || !instance.cards.length) return;

    const cardEl = blockEl.closest('[data-focus-card]');
    if (!cardEl) return;

    const selectedIndex = instance.cards.findIndex((card) => card === cardEl);
    if (selectedIndex >= 0) {
      instance.goTo(selectedIndex, { force: true });
    }
  });
})();
